import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import * as jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import * as alasql from 'alasql';
const $ = jQuery;

@Component({
  selector: 'app-cierant-dynamic-report',
  templateUrl: './cierant-dynamic-report.component.html',
  styleUrls: ['./cierant-dynamic-report.component.scss']
})
export class CierantDynamicReportComponent implements OnInit {
  @Input() items: Array<any> = [];
  columns = [];
  @ViewChild('content') content:ElementRef;
  @Input() title = 'Excel'; 
  bodyColor: string;
  @Input() showLinks: boolean;
  
  constructor() { }

  ngOnInit() {
    this.bodyColor = $('body').css('border-top').replace('5px solid ', '');
    if (this.items && this.items.length > 0) {
      for (const i in this.items[0]) {
        if (typeof this.items[0][i] !== 'object')
          this.columns.push(i);
      }
    }
  }

  public SavePDF(): void {  
    let content=this.content.nativeElement;  
    let doc = new jsPDF('l', 'mm', 'a4');  
    let _elementHandlers =  
    {  
      '#editor':function(element,renderer){  
        return true;  
      }  
    };  
    doc.fromHTML(content.innerHTML,15,15,{  
      'width':190,  
      'elementHandlers':_elementHandlers,
    });  
  
    doc.save('test.pdf');  
  }

  ExportTOExcel() {  
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.items.map(i => {
      const item = {};
      this.columns.forEach(column => {
        item[column] = i[column];
      });
      return item;
    }));  
    const wb: XLSX.WorkBook = XLSX.utils.book_new();  
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');  
    XLSX.writeFile(wb, `${this.title}.xlsx`);  
  }

  ExportToXlsx() {
    let DataForSheet1: any[] = [];
    DataForSheet1.concat(this.items);
    var opts = [{ sheeitd: "Sheet 1", header: true }, { sheeitd: "Sheet 2", header: true }]  
  }

  isLink(val) {
    if (val && 
      (
        val.toString().indexOf('http://') > -1 || 
        val.toString().indexOf('https://') > -1 ||
        val.toString().indexOf('#/') > -1) && 
      this.showLinks
    )
      return true; 

    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/cierant-dynamic-report/cierant-dynamic-report.component.ts